import jwtDecode from 'jwt-decode';
import { compose, pick, prop } from 'ramda';

import { UPDATE_AUTH } from '@/constants';

const getUserProfile = () => {
  try {
    return compose(
      pick(['email', 'name', 'nickname', 'picture']),
      jwtDecode,
    )(localStorage.getItem('id_token'));
  } catch (e) {
    return null;
  }
};

const getExpiresAt = () => localStorage.getItem('expires_at');

export default {
  state: {
    error: null,
    expiresAt: getExpiresAt(),
    userProfile: getUserProfile(),
  },

  mutations: {
    [UPDATE_AUTH]: (state, error = null) => {
      state.error = error;
      state.expiresAt = getExpiresAt();
      state.userProfile = getUserProfile();
    },
  },

  getters: {
    getAuthError: prop('error'),
    getUserProfile: prop('userProfile'),
  },
};
